import { LinkedinLogo } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import { Tag } from "common/components/ui/Tag";

import SectionContainer from "./SectionContainer";

import type { JSX } from "react";

export default function LinkedInSubscription({
  hasPremium,
  isLoading,
}: {
  hasPremium: boolean;
  isLoading: boolean;
}) {
  let content = <Skeleton className="h-6 w-28" />;

  if (!isLoading) {
    let leftIcon: JSX.Element,
      tagContent = "Free";

    if (hasPremium) {
      leftIcon = <LinkedinLogo className="fill-yellow-500" weight="fill" />;
      tagContent = "LinkedIn Premium";
    }

    content = (
      <Tag variant="tertiary" leftIcon={leftIcon}>
        {tagContent}
      </Tag>
    );
  }
  return (
    <SectionContainer title="LinkedIn subscription" hasBorder isColumn={false}>
      {content}
    </SectionContainer>
  );
}
